export const validMeasurementUnit = (unit) => unit === 'cm' || unit === 'in';

export const measurementValue = (dataset, unit) => {
  if (!validMeasurementUnit(unit)) return null;
  const value = dataset?.[unit];
  return typeof value === 'string' ? value : null;
};

const applyMeasurementUnit = (guide, unit) => {
  if (!guide || !validMeasurementUnit(unit)) return false;

  guide.querySelectorAll('[data-cm][data-in]').forEach((cell) => {
    const value = measurementValue(cell.dataset, unit);
    if (value !== null) cell.textContent = value;
  });

  guide.querySelectorAll('[data-measurement-unit]').forEach((button) => {
    const active = button.dataset.measurementUnit === unit;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  });

  guide.querySelectorAll('[data-measurement-unit-label]').forEach((label) => {
    label.textContent = unit;
  });

  const intro = guide.querySelector('[data-measurement-intro]');
  if (intro) {
    const copy = unit === 'in' ? intro.dataset.introIn : intro.dataset.introCm;
    if (copy) intro.textContent = copy;
  }

  return true;
};

const closeDialog = (dialog) => {
  if (!dialog) return;
  if (typeof dialog.close === 'function') dialog.close();
  else dialog.removeAttribute('open');
};

const initializeSizeFit = (root = document) => {
  root.querySelectorAll('[data-size-fit-dialog]:not([data-size-fit-ready])').forEach((dialog) => {
    dialog.dataset.sizeFitReady = 'true';

    dialog.querySelector('[data-size-fit-close]')?.addEventListener('click', () => closeDialog(dialog));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog(dialog);
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDialog(dialog);
      }
    });
    dialog.addEventListener('close', () => {
      const trigger = document.querySelector('[aria-controls="' + dialog.id + '"]');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });
  });

  root.querySelectorAll('[data-measurement-guide]:not([data-measurement-ready])').forEach((guide) => {
    guide.dataset.measurementReady = 'true';
    guide.querySelectorAll('[data-measurement-unit]').forEach((button) => {
      button.addEventListener('click', () => {
        const unit = button.dataset.measurementUnit;
        if (!applyMeasurementUnit(guide, unit)) return;
        window.BudzikoEvidence?.track('size_guide.unit_changed', {
          product_id: guide.dataset.productId,
          unit,
        });
      });
    });
  });
};

if (typeof document !== 'undefined') {
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-size-fit-open]');
    if (!trigger) return;
    const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!dialog) return;
    trigger.setAttribute('aria-expanded', 'true');
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    dialog.querySelector('[data-size-fit-close]')?.focus();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeSizeFit(), { once: true });
  } else {
    initializeSizeFit();
  }

  document.addEventListener('shopify:section:load', (event) => initializeSizeFit(event.target));
}
